import React from 'react';
import { Helmet } from 'react-helmet';

const SEOHelmet = ({ title, description, keywords, canonical }) => {
  // Create dynamic canonical URL
  const getDynamicCanonical = () => {
    if (!canonical) return window.location.href;
    
    // If it's a relative URL, make it absolute
    if (canonical.startsWith('/')) {
      return window.location.origin + canonical;
    }
    
    // If it contains the hardcoded domain, replace it
    if (canonical.includes('legaldocspecialist.com')) {
      return canonical.replace('https://legaldocspecialist.com', window.location.origin);
    }
    
    // Otherwise use as-is
    return canonical;
  };

  const dynamicCanonical = getDynamicCanonical();

  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <link rel="canonical" href={dynamicCanonical} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={dynamicCanonical} />
      <meta property="og:type" content="website" />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
    </Helmet>
  );
};

export default SEOHelmet;